import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { t } from 'i18next';

/**
 * A functional component that renders an input field for the resting heart rate.
 **/
export const TextFieldRestingHeartRate = ({ values, handleChange, errors, touched }) => (
    <TextField
        fullWidth
        label={t('users.fields.restingHR')}
        type="tel"
        name="restingHeartRate"
        value={values.restingHeartRate}
        error={touched.restingHeartRate && Boolean(errors.restingHeartRate)}
        helperText={touched.restingHeartRate && errors.restingHeartRate}
        onChange={handleChange}
    />
);

TextFieldRestingHeartRate.propTypes = {
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired
};
